module.exports = __webpack_public_path__ + "static/img/h5-4.4d6cf6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/h5-4.png
// module id = 3fjG
// module chunks = 1